import { render, staticRenderFns } from "./PanelSettings.vue?vue&type=template&id=1b249b3a&"
import script from "./PanelSettings.vue?vue&type=script&lang=js&"
export * from "./PanelSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports